import { useState } from 'react';
import Popup from 'src/components/Popup';

interface AssignmentPopupProps {
  isOpen: boolean;
  onClose: () => void;
  memberId: string;
}

const AssignmentPopup = ({ isOpen, onClose, memberId }: AssignmentPopupProps) => {
  const [value, setValue] = useState('5.5');
  const [assignDTQ, setAssignDTQ] = useState(false);

  const handleAssign = () => {
    onClose();
  };

  return (
    <Popup isOpen={isOpen} onClose={onClose}>
      <h2 className="text-lg font-semibold">Assignment</h2>
      
      <p className="text-sm text-gray-600 mb-4">
        You are about to evaluate PHQ for the member ID.
      </p>
      
      <div className="text-2xl font-bold mb-3">
        {memberId}
      </div>
      
       <div className="mb-3">
         <div className="relative">
           <select
             value={value}
             onChange={(e) => setValue(e.target.value)}
             className="w-full px-4 py-3 border border-gray-300 cursor-pointer outline-none rounded-lg appearance-none bg-white"
           >
             <option value="5.5">5.5</option>
             <option value="6.5">6.5</option>
           </select>
           <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
             <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
             </svg>
           </div>
         </div>
       </div>
      
      <div className="mb-6">
        <label className="flex items-center cursor-pointer">
          <input
            type="checkbox"
            checked={assignDTQ}
            onChange={(e) => setAssignDTQ(e.target.checked)}
            className="w-4 h-4 bg-red-700 border-gray-300 rounded"
          />
          <span className="ml-2 text-sm">Assign DTQ</span>
        </label>
      </div>
      
      <div className="flex gap-3">
        <button
          onClick={onClose}
          className="flex-1 px-4 py-2 bg-light-gray rounded-full hover:bg-gray-300 transition-colors"
        >
          Cancel
        </button>
        <button
          onClick={handleAssign}
          className="flex-1 px-4 py-2 bg-secondary-bg text-white rounded-full transition-colors"
        >
          Assign
        </button>
      </div>
    </Popup>
  );
};

export default AssignmentPopup;